import { storyblokEditable } from "@storyblok/react";
import Link from "next/link";

const ImgTextArticle = ({ blok }) => (
  <div className="imgtextarticle-outer wrap">
    <div
      className="imgtextarticle-wrap inner-wrap flex"
      {...storyblokEditable(blok)}
    >
      <div className="imgtextarticle-text-wrap flex flex-col">
        <h2 className="imgtextarticle-headline text-6xl">{blok.headline}</h2>

        <div className="imgtextarticle-contentOuter">
          <div className="imgtextarticle-contentLeft">
            <div className="imgtextarticle-content flex flex-col">
              <div className="imgtextarticle-wrap-left flex">
                <div className="imgtextarticleOne-image">
                  <img
                    src={blok.articleOneImage.filename}
                    alt={blok.articleOneImage.alt}
                  />
                </div>
              </div>

              <div className="imgtextarticle-textContent">
                <h2 className="text-4xl">{blok.articleOneSubheadline}</h2>

                <div className="imgtextarticle-text">
                  <p>{blok.articleOneText}</p>
                  {blok.textleft2 && <p className="pt-2">{blok.textleft2}</p>}
                </div>

                <h3 className="imgtextarticle-datesubheadline text-2xl">{blok.articleOneSubheadline2}</h3>

                <Link href={blok.articleOneLink} target="_blank" >
                    <button className="imgtextarticleOne-btn">
                      {blok.articleOneButton}
                    </button>
                </Link>
              </div>

            </div>
          </div>

          <div className="imgtextarticle-contentRight">
            <div className="imgtextarticle-content flex flex-col">
              <div className="imgtextarticle-wrap-left flex">
                <div className="imgtextarticleTwo-image">
                  <img
                    src={blok.articleTwoImage.filename}
                    alt={blok.articleTwoImage.alt}
                  />
                </div>
              </div>

              <h2 className="text-4xl">{blok.articleTwoSubheadline}</h2>

              <div className="imgtextarticle-text2">
                <p>{blok.articleTwoText}</p>
                {blok.textright2 && <p className="pt-2">{blok.textright2}</p>}
              </div>
              <Link target="_blank" href={blok.articleTwoLink} >
                  <button className="imgtextarticle-btn">
                    {blok.articleTwoButton}
                  </button>
              </Link>
            </div>

            <div className="imgtextarticle-hrLine"></div>

            <div className="imgtextarticle-content flex flex-col">
              <div className="imgtextarticle-wrap-left flex">
                <div className="imgtextarticleThree-image">
                  <img
                    src={blok.articleThreeImage.filename}
                    alt={blok.articleThreeImage.alt}
                  />
                </div>
              </div>

              <h2 className="text-4xl">{blok.articleThreeSubheadline}</h2>

              <div className="imgtextarticle-text2">
                <p>{blok.articleThreeText}</p>
                {blok.textright4 && <p className="pt-2">{blok.textright4}</p>}
              </div>

              {blok.articleThreeButton && (
                <Link target="_blank" href={blok.articleThreeLink} >
                    <button className="imgtextarticle-btn">
                      {blok.articleThreeButton}
                    </button>
                </Link>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default ImgTextArticle;
